import { render, staticRenderFns } from "./ModalAddFriend.vue?vue&type=template&id=701f1e94&scoped=true&"
import script from "./ModalAddFriend.vue?vue&type=script&lang=js&"
export * from "./ModalAddFriend.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddFriend.vue?vue&type=style&index=0&id=701f1e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f1e94",
  null
  
)

export default component.exports